import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AdminTransactionsScreen = () => {
  const [activeTab, setActiveTab] = useState('single-entry');
  const [formData, setFormData] = useState({
    userEmail: '',
    monthYear: '',
    amount: '',
    currency: '',
    type: '',
    exchangeRate: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Mock API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      toast.success('Transaction added successfully!');
      setFormData({
        userEmail: '',
        monthYear: '',
        amount: '',
        currency: '',
        type: '',
        exchangeRate: ''
      });
    } catch (error) {
      toast.error('An error occurred while adding the transaction');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('is_admin');
    navigate('/admin');
  };

  return (
    <div className="container">
      <div className="admin-header-fullwidth">
        <div className="admin-header-content">
          <div className="admin-header-left">
            <img src="/logo.svg" alt="Project 31 Logo" className="admin-logo" />
         
          </div>
          
          <div className="admin-nav">
            <a href="/admin/dashboard">Dashboard</a>
            <a href="/admin/transactions">Transactions</a>
              <a href="/admin/manage-accounts">Accounts</a>
            <a href="/admin/bitcoins">Bitcoins</a>
          </div>
        </div>
      </div>

      <div className="dashboard-content admin-dashboard-content">
        <div className="transaction-upload-section">
          <h2>Transaction Upload & Reconciliation</h2>
          
          <div className="upload-tabs">
            <button
              className={`tab-button ${activeTab === 'single-entry' ? 'active' : ''}`}
              onClick={() => setActiveTab('single-entry')}
            >
              Single Transaction Entry
            </button>
            <button
              className={`tab-button ${activeTab === 'batch-upload' ? 'active' : ''}`}
              onClick={() => setActiveTab('batch-upload')}
            >
              Batch Upload
            </button>
          </div>

          {activeTab === 'single-entry' ? (
            <div className="single-transaction-section">
              <h3>Single Transaction Entry</h3>
              
              <form onSubmit={handleSubmit} className="transaction-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="userEmail">User Email</label>
                    <input
                      type="email"
                      id="userEmail"
                      name="userEmail"
                      value={formData.userEmail}
                      onChange={handleInputChange}
                      placeholder="Enter user's email"
                      required
                      disabled={isLoading}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="monthYear">Month & Year</label>
                    <input
                      type="text"
                      id="monthYear"
                      name="monthYear"
                      value={formData.monthYear}
                      onChange={handleInputChange}
                      placeholder="Select Month & Year"
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="amount">Amount</label>
                    <input
                      type="number"
                      id="amount"
                      name="amount"
                      value={formData.amount}
                      onChange={handleInputChange}
                      placeholder="Enter amount"
                      required
                      disabled={isLoading}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="currency">Currency</label>
                    <input
                      type="text"
                      id="currency"
                      name="currency"
                      value={formData.currency}
                      onChange={handleInputChange}
                      placeholder="Select Currency"
                      required
                      disabled={isLoading}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="type">Type</label>
                    <input
                      type="text"
                      id="type"
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                      placeholder="Select Type"
                      required
                      disabled={isLoading}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="exchangeRate">Exchange Rate</label>
                    <input
                      type="number"
                      id="exchangeRate"
                      name="exchangeRate"
                      value={formData.exchangeRate}
                      onChange={handleInputChange}
                      placeholder="Enter exchange rate (required for fiat currencies)"
                      disabled={isLoading}
                    />
                  </div>
                </div>
                
                <div className="form-actions">
                  <button
                    type="submit"
                    className="add-transaction-button"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Adding...' : 'Add Transaction'}
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <form
              className="batch-upload-section"
              onSubmit={(e) => e.preventDefault()}
            >
              <h3>Batch Upload</h3>

              <div className="upload-zone">
                <div className="upload-content">
                  <div className="upload-text">Drag and drop or browse</div>
                  <div className="upload-subtext">CSV/XLSX files only</div>
                  <button type="button" className="browse-button">Browse</button>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="batchMonthYear">Month & Year</label>
                  <input
                    type="text"
                    id="batchMonthYear"
                    name="batchMonthYear"
                    placeholder="Select Month & Year"
                    disabled={isLoading}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="batchCurrency">Currency</label>
                  <input
                    type="text"
                    id="batchCurrency"
                    name="batchCurrency"
                    placeholder="Select Currency"
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="exchange-rate-note">
                Exchange rates for the selected fiat currency will be entered in the next step.
              </div>

              <div className="form-actions">
                <button
                  type="submit"
                  className="upload-preview-button"
                  disabled={isLoading}
                >
                  {isLoading ? 'Processing...' : 'Upload & Preview'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      <div className="admin-footer">
        <button onClick={handleLogout} className="admin-logout-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminTransactionsScreen;

